import { render, staticRenderFns } from "./FileTypeButton.vue?vue&type=template&id=909c5510&scoped=true&"
import script from "./FileTypeButton.vue?vue&type=script&lang=js&"
export * from "./FileTypeButton.vue?vue&type=script&lang=js&"
import style0 from "./FileTypeButton.vue?vue&type=style&index=0&id=909c5510&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "909c5510",
  null
  
)

export default component.exports